import React from 'react';
import { useTranslation } from 'react-i18next';
import AccordionsGroup from '../../../../components/AccordionsGroup/AccordionsGroup';
import Crest from './Crest/Crest';
import RockSlope from './RockSlope/RockSlope';
import Mesh from './Mesh/Mesh';
import SiteEnvLevel from './SiteEnvLevel/SiteEnvLevel';
import SafetyCoefficients from './SafetyCoefficients/SafetyCoefficients';
import { getMacro2ProjectAsync, putMacro2ProjectAsync } from '../../../api/store/BeMaccaferriStoreHelper';
import { setProject, dataToProject, projectToData, commitProject, setReadOnly, setHasBeenRan, setDisableRun} from '../../store/project/projectslice';
import { setOutputData,} from '../../store/project/resultsSlice';
import { useParams } from "react-router-dom";
import Dialog from '../../../../components/Dialog/Dialog';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../reduxService/hooks';
import { selectMacro2, selectProjectInfo, setProjectInfo, setHasBeenSent } from '../../../store/projectInfo/projectInfoSlice';
import { IMacro2ProjectPutData } from '../../../api/IApiRequest';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../reduxService';
import { useSelector } from 'react-redux';
import { getMeshTypes } from '../../../api/products/BeMaccaferriProductsHelper';


const InputForm = () => {
    
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { id } = useParams();
    const [loading, setLoading] = React.useState<boolean>(true);
    const [noMeshes, setNoMeshes] = React.useState<boolean>(false);
    const [onlyExport, setOnlyExport] = React.useState<boolean>(false);
    const projectInfo = useAppSelector(selectProjectInfo);

    const [ErrorDialog, setErrorDialog] = React.useState<string>('');
    const closeErrorDialog = () => {
        setErrorDialog('');
    }

    const [currentDialog, setCurrentDialog] = React.useState<string>('');
    
    const closeDialog = () => {
        setCurrentDialog('');
    }

    const optEdit = () => {
        setLoading(false);
        closeDialog();
    }

    const optExport = () => {
        sendProjectData();
        setTimeout(()=>{navigate(`/results/${macro2.project.data?.projectInfo?.projectType}/${macro2.project.data?.projectInfo?.projectId}`);}, 2000);
        setOnlyExport(true);
        dispatch(setDisableRun(false));
        dispatch(setHasBeenSent(true));
        dispatch(setHasBeenRan(true));
        setLoading(false);
        closeDialog();
    }

    const noMeshesCases = () => {
        dispatch(setReadOnly(true));
        if(!currentProjectM2.hasBeenRan) {
            dispatch(setDisableRun(true));
        } else {
            dispatch(setDisableRun(false));
        }
        closeErrorDialog();
    };

    const [FirstLoad, setFirstLoad] = React.useState<boolean>(true);

    const backToRoot = () => {
        window.location.href = '/';
    }

    const macro2 = useAppSelector(selectMacro2);

    const dispatch = useAppDispatch();

    
    //Check if there are meshes in the Mesh Types list
    useEffect(() => {
        async function getMacro2MeshTypesAsync() { 
            if( !!projectInfo.data?.unit){
                try {
                    const response = (await getMeshTypes()).data;
                    let meshTypeList = response;
                    if(meshTypeList.length <= 0) {
                        setNoMeshes(true);
                        setErrorDialog('error');
                    }
                } catch (error) {
                    console.error('getMacro1MeshTypes');
                    setNoMeshes(true);
                    setErrorDialog('error');
                }
            }
        }

        getMacro2MeshTypesAsync();
    }, [projectInfo.data?.unit, window.localStorage.getItem("i18nextLng")]);

    useEffect(() => {
        async function getProj() {
            //console.log("IF **********", id, macro2.project.data?.projectInfo?.projectId);
            if (id && !macro2.project.data?.projectInfo?.projectId) {
                try {
                    const res = await getMacro2ProjectAsync(id);
                    if (res.data.projectInfos) {
                        dispatch(setProjectInfo({ projectId: id, ...res.data.projectInfos, hasBeenSent: location.pathname.split("/")[1] == 'results' }));
                        setCurrentDialog(res.data.readOnly ? 'Open' : '');
                    }
                    dispatch(setProject(dataToProject(res.data)));
                    dispatch(commitProject(dataToProject(res.data)));
                    if (location.pathname.split("/")[1] == 'results') {
                        if(!res.data.hasBeenRan){
                            window.location.href=`/designCondition/${res.data?.projectInfos?.projectType}/${res.data?.projectId}`;
                            return;
                        }
                        const results = (await putMacro2ProjectAsync({ ...res.data, id: res.data.projectId } as IMacro2ProjectPutData)).data;
                        dispatch(setOutputData(results));
                        dispatch(setHasBeenSent(true));
                    }
                    if (!res.data.readOnly) {
                        setLoading(false);
                    }
                } catch (error) {
                    console.error("getProj", error);
                    setErrorDialog('error');
                }
            } else {
                setCurrentDialog(macro2.project.data?.readOnly ? 'Open' : '');
                if (!macro2.project.data?.readOnly) {
                    setLoading(false);
                }
            }
        }
        if (FirstLoad) {
            getProj();
            setFirstLoad(false);
        } else {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        dispatch(setHasBeenSent(false));
        if (!loading && location.pathname.split("/")[1] == 'results') {
            navigate(`/designCondition/${macro2.project.data?.projectInfo?.projectType}/${macro2.project.data?.projectInfo?.projectId}`);
        }
    }, [
        macro2.project.data?.crest
        , macro2.project.data?.mesh
        , macro2.project.data?.safetyCoefficients
        , macro2.project.data?.siteEnvironmentalLevelId
        //RockSlope
        , macro2.project.data?.rockSlope?.debrisAccumulationHeight
        , macro2.project.data?.rockSlope?.debrisAccumulationWidth
        , macro2.project.data?.rockSlope?.debrisFrictionAngle
        , macro2.project.data?.rockSlope?.debrisUnitWeight
        , macro2.project.data?.rockSlope?.inclination
        , macro2.project.data?.rockSlope?.meshSlopeFrictionAngle
        , macro2.project.data?.rockSlope?.slopeTotalHeight
        , macro2.project.data?.rockSlope?.snow
        , macro2.project.data?.rockSlope?.snowThickness
        , macro2.project.data?.rockSlope?.snowUnitWeight    
        , macro2.project.data?.readOnly
        , macro2.project.data?.hasBeenRan
    ]);

    useEffect(() => {
        if(window.location.href.includes('/designCondition/') && macro2.project.data?.readOnly){
            setCurrentDialog('Open');
        }
    },[window.location.href]);

    const currentProjectM2 = useSelector((state: RootState) => {
        return { ...state.Macro2.project.data };
    });

    const sendProjectData = async () => {
        try {
                currentProjectM2.projectId = id;
                const results = (await putMacro2ProjectAsync(projectToData(currentProjectM2)));
                dispatch(commitProject(currentProjectM2));
                dispatch(setOutputData(results.data));
            } catch (ex) {
                setErrorDialog(((ex as any)?.response?.data?.PropertiesNotValid ?? '' + t('errors.projectCommit.unspecific_error')).replaceAll(", ", "\n"));
            }
        dispatch(setHasBeenSent(true));
    }
    
    return (
        <div className='d-flex flex-column'>
            <Dialog
                open={!!ErrorDialog && ErrorDialog.length > 0}
                title={`${t('errors.projectGet.title')}`}
                onClose={backToRoot}
                actions={[{
                    text: 'ok',
                    callback: backToRoot,
                    color: 'primary'
                }
                ]}>
                <div>
                    {`${t('errors.projectGet.message')}`}
                </div>
            </Dialog>
            <Dialog
                open={!!ErrorDialog && ErrorDialog.length > 0 && noMeshes}
                title={`${t('errors.noMeshTypes.title')}`}
                onClose={noMeshesCases}
                actions={[{
                    text: 'ok',
                    callback: noMeshesCases,
                    color: 'primary'
                }
                ]}>
                <div>
                    {`${t('errors.noMeshTypes.message')}`}
                </div>
            </Dialog>
            <Dialog
                open={currentDialog!='' && !ErrorDialog && ErrorDialog == '' && !noMeshes && location.pathname.split("/")[1] == 'designCondition'}
                title={`${t('errors.unavailableMesh.title')}`}
                onClose={optEdit}
                actions={[{
                    text: t('errors.unavailableMesh.opt1'),
                    callback: optExport,
                    color: 'primary'
                },
                {
                    text: t('errors.unavailableMesh.opt2'),
                    callback: optEdit,
                    color: 'primary'}
            ]}> 
                <>
                    <div>
                        {`${t('errors.unavailableMesh.message')}`}
                    </div>
                </>
            </Dialog>
            {loading || noMeshes || onlyExport ? <></> : <AccordionsGroup
                items={
                    [
                        {
                            title: t('input_form_accordion_rock_slope'),
                            children: <RockSlope readOnly={macro2.project.data?.readOnly}/>
                        },
                        {
                            title: t('input_form_accordion_site_env_level'),
                            children: <SiteEnvLevel readOnly={macro2.project.data?.readOnly}/>
                        },
                        {
                            title: t('input_form_accordion_mesh'),
                            children: <Mesh readOnly={macro2.project.data?.readOnly}/>
                        },
                        {
                            title: t('input_form_accordion_crest'),
                            children: <Crest readOnly={macro2.project.data?.readOnly}/>
                        },
                        {
                            title: t('input_form_accordion_safety_coefficients'),
                            children: <SafetyCoefficients readOnly={macro2.project.data?.readOnly}/>
                        }
                    ]
                } />}
        </div>
    );
};

export default InputForm;
